import { initializeAnalytics } from './utils/analyticsBootstrap';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import './index.css';
import './styles/print.css';
import App, { preloadSupportRoutes } from './App';
import reportWebVitals from './reportWebVitals';
import { createEmotionCache } from './theme/createEmotionCache';
import { trackWebVital } from './utils/analytics';

initializeAnalytics();

const container = document.getElementById('root') as HTMLElement;
const emotionCache = createEmotionCache();

const renderApp = async () => {
  // Support pages are prerendered with their complete article tree. Load the
  // isolated support route bundle before hydration so React's first client
  // render matches that HTML instead of briefly rendering a Suspense loader.
  const isSupportRoute = window.location.pathname.startsWith('/support');
  if (isSupportRoute) {
    await preloadSupportRoutes();
  }

  const app = (
    <CacheProvider value={emotionCache}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </CacheProvider>
  );

  if (container.hasChildNodes() && !isSupportRoute) {
    hydrateRoot(container, app);
  } else {
    // The restored article HTML comes from a strict archive sanitizer and can
    // contain legacy table/layout structures that browsers normalize before
    // React sees them. Preserve the crawlable HTML until the support bundle is
    // ready, then mount cleanly instead of forcing a noisy hydration recovery.
    if (isSupportRoute) container.replaceChildren();
    const root = createRoot(container);
    root.render(app);
  }
};

void renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(trackWebVital);
